export var PACKAGE_SOURCE = "board-components";
export var PACKAGE_VERSION = "3.0.0 (af05dce2)";
export var THEME = "polaris";
export var ALWAYS_VISUAL_REFRESH = false;